export interface Health {
  status: string;
  version: string;
}

/**
 * Calls the backend liveness endpoint. At M1 this is replaced by the generated
 * `openapi-fetch` client over `schema.d.ts` (ADR-022 section 9); the shape below is the
 * hello-world slice only.
 */
export async function fetchHealth(signal?: AbortSignal): Promise<Health> {
  const response = await fetch("/api/health", { signal: signal ?? null });
  if (!response.ok) {
    throw new Error(`Health request failed: ${String(response.status)}`);
  }
  return (await response.json()) as Health;
}
